import type { RouteRecordRaw } from "vue-router";

export const fleetManagerRoutes: RouteRecordRaw[] = [
  {
    path: "/fleet-manager",
    meta: { requiresAuth: true, requiresStaff: true, pageHeader: "page_headers.fleet_manager" },
    children: [
      {
        path: "",
        name: "fleet-manager",
        component: () => import("../../views/fleet-manager/FleetManager.vue"),
      },
      {
        path: "software-versions",
        children: [
          {
            path: "",
            name: "software-versions",
            component: () => import("../../views/fleet-manager/software-version/List.vue"),
          },
          {
            path: "new",
            name: "new-software-version",
            component: () => import("../../views/fleet-manager/software-version/Create.vue"),
          },
          {
            path: ":id",
            name: "view-software-version",
            redirect: { name: "software-versions" },
          },
        ],
      },
    ],
  },
];
